import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogTitle, DialogContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import Button from 'components/Button';

const useStyles = makeStyles(() => ({
  noPadding: {
    padding: '0 !important',
  },
  content: {
    minHeight: '80vh',
  },
  iframe: {
    height: '80vh',
  },
}));

export default function PdfView(props) {
  const { fileName, fileUrl, handleClose } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const [openPrintResult, setOpenPrintResult] = useState(false);

  const handleCloseDialog = () => {
    setOpenPrintResult(false);
    // eslint-disable-next-line no-unused-expressions
    handleClose && handleClose();
  };

  useEffect(() => {
    if (fileName && fileUrl) {
      setOpenPrintResult(true);
    }
  }, [fileName, fileUrl]);

  return (
    <Dialog
      open={openPrintResult}
      onClose={handleCloseDialog}
      aria-labelledby="form-dialog-title"
      scroll="paper"
      disableBackdropClick
      maxWidth="xl"
      fullWidth
    >
      <DialogTitle>{fileName}</DialogTitle>
      <DialogContent className={clsx(classes.noPadding, classes.content)}>
        {openPrintResult && <iframe src={fileUrl} title="title" className={clsx('w-full', classes.iframe)} />}
      </DialogContent>
      <DialogActions>
        <div className="flex justify-end w-full">
          <Button onClick={handleCloseDialog}>{t('BUTTON_CLOSE')}</Button>
        </div>
      </DialogActions>
    </Dialog>
  );
}
